import { render, staticRenderFns } from "./sidebar.component.html?vue&type=template&id=616134e7&scoped=true&external"
import script from "./sidebar.component.ts?vue&type=script&lang=ts&external"
export * from "./sidebar.component.ts?vue&type=script&lang=ts&external"
import style0 from "./sidebar.component.scss?vue&type=style&index=0&id=616134e7&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616134e7",
  null
  
)

export default component.exports